import type { ComponentProps, ReactNode } from "react";

import { CircleX } from "lucide-react";

import { inputStyle } from "./input.styles";

export type InputProps = Omit<ComponentProps<"input">, "prefix"> & { prefix?: ReactNode; clearable?: boolean; onClear?: () => void };

export const Input = ({ ref, className, type, prefix, clearable, onClear, value, ...props }: InputProps) => {
  return (
    <div className="relative">
      {prefix && (
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          {prefix}
        </div>
      )}
      <input
        type={type}
        value={value}
        className={inputStyle(!!prefix, !!clearable, className,
        )}
        ref={ref}
        {...props}
      />
      {clearable && value && (
        <div className="absolute right-1 top-1/2 -translate-y-1/2 cursor-pointer rounded-full p-1 text-white">
          <CircleX onClick={onClear} className="ml-auto size-4 opacity-50" />
        </div>
      )}
    </div>
  );
};
